"use client";

import { Icon } from "@/components/ui/icon";

export interface ShowMoreButtonProps {
  expanded: boolean;
  onToggle: () => void;
  expandLabel?: string;
  collapseLabel?: string;
}

/**
 * Full-width pill button rendered at the bottom of the technical-profile
 * card to expand / collapse the GitHub repo list. Matches the design
 * screenshots: rounded-full border, neutral background, chevron icon.
 */
export function ShowMoreButton({
  expanded,
  onToggle,
  expandLabel = "Show more",
  collapseLabel = "Show less",
}: ShowMoreButtonProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex w-full items-center justify-center gap-1.5 rounded-full border border-border bg-surface-elevated px-4 py-2 text-sm font-medium text-foreground/70 transition-colors hover:bg-contrast/4 hover:text-foreground"
    >
      <span>{expanded ? collapseLabel : expandLabel}</span>
      <Icon
        name={expanded ? "IconChevronTop" : "IconChevronDownSmall"}
        size={16}
        className="text-foreground/50"
      />
    </button>
  );
}
